<!-- breadcrumb.component.html -->
<nav>
  <ng-container> <mat-icon matListItemIcon>home</mat-icon></ng-container>
  <div class="breadcrumb">
    <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last">
      <ng-container *ngIf="!last">
        <span class="my-1">&gt;</span> <a [routerLink]="breadcrumb.url">{{ breadcrumb.label }}</a>
      </ng-container>
      <ng-container *ngIf="last"> <span class="my-1">&gt;</span> {{ breadcrumb.label }} </ng-container>
    </ng-container>
  </div>
</nav>
